import { render, staticRenderFns } from "./pt-feedback-table.vue?vue&type=template&id=1ebdf4d4&"
import script from "./pt-feedback-table.vue?vue&type=script&lang=js&"
export * from "./pt-feedback-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports